import React from "react";
import {withRouter} from "react-router-dom";
import {Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {
    Fingerprint as PasswordIcon,
    Help as HelpIcon,
    Info as AboutIcon,
    Logout as LogoutIcon,
    Notifications as NotificationsIcon,
    Settings as SettingsIcon,
    Wysiwyg as TemplateIcon,
    YouTube as YouTubeIcon,
} from "@mui/icons-material";
import {confirm, mobile, router} from "@atttomyx/react-utils";
import {PAGE_ABOUT, PAGE_NOTIFICATIONS, PAGE_PASSWORD, PAGE_SETTINGS, PAGE_TEMPLATES} from "../../constants";
import "./moreMenu.css";

const MoreMenu = (props) => {
    const {history, user, onCancel, onLogout, onHelp, numNotifications} = props;

    const closeAndRedirect = (page) => {
        onCancel();
        router.redirectTo(history, page);
    };

    return <Drawer
        anchor="right"
        className="more-menu"
        open={true}
        onClose={onCancel}
    >
        <List>
            <ListItemButton onClick={() => closeAndRedirect(PAGE_NOTIFICATIONS)}>
                <ListItemIcon><NotificationsIcon color={numNotifications > 0 ? "error" : undefined}/></ListItemIcon>
                <ListItemText>Notifications</ListItemText>
            </ListItemButton>
            {user.roles.admin ?
                <ListItemButton onClick={() => closeAndRedirect(PAGE_TEMPLATES)}>
                    <ListItemIcon><TemplateIcon/></ListItemIcon>
                    <ListItemText>Templates</ListItemText>
                </ListItemButton> : null}
            <Divider/>
            <ListItemButton onClick={() => closeAndRedirect(PAGE_SETTINGS)}>
                <ListItemIcon><SettingsIcon/></ListItemIcon>
                <ListItemText>Settings</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => closeAndRedirect(PAGE_PASSWORD)}>
                <ListItemIcon><PasswordIcon/></ListItemIcon>
                <ListItemText>Password</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => confirm.confirm(mobile.isMobile()
                ? "Someone would need to have physical access to your phone to access this account. Are you sure you want to logout?"
                : "Are you sure you want to logout?", onLogout)}>
                <ListItemIcon><LogoutIcon/></ListItemIcon>
                <ListItemText>Logout</ListItemText>
            </ListItemButton>
            <Divider/>
            <ListItemButton onClick={() => closeAndRedirect(PAGE_ABOUT)}>
                <ListItemIcon><AboutIcon/></ListItemIcon>
                <ListItemText>About</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={onHelp}>
                <ListItemIcon><HelpIcon/></ListItemIcon>
                <ListItemText>Help</ListItemText>
            </ListItemButton>
            <Divider/>
            <ListItemButton onClick={() => window.open("https://www.youtube.com/@inventorsarena?sub_confirmation=1", "_blank")}>
                <ListItemIcon><YouTubeIcon/></ListItemIcon>
                <ListItemText>YouTube</ListItemText>
            </ListItemButton>
        </List>
    </Drawer>
};

export default withRouter(MoreMenu);
